module.exports = __webpack_public_path__ + "img/album14_29.5f5314aa.jpg";